module.exports = __webpack_public_path__ + "img/3-3-IMG_3001.4836f270.png";